var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20608 4.37294C6.78354 4.17624 7.64784 4 8.88889 4C10.1857 4 11.2623 4.36683 12.2153 4.69152L12.2523 4.70411C13.2346 5.03873 14.0913 5.32468 15.1111 5.32468C16.2034 5.32468 16.8947 5.16974 17.2894 5.03528C17.487 4.96796 17.6124 4.90511 17.6784 4.86764C17.7103 4.8495 17.7287 4.83709 17.7351 4.83268C17.9643 4.64965 18.2788 4.61036 18.5472 4.73303C18.8232 4.85913 19 5.13329 19 5.43506V13.3831C19 13.6087 18.9008 13.823 18.7284 13.9698L18.2222 13.3831C18.7284 13.9698 18.728 13.9702 18.7275 13.9705L18.7266 13.9713L18.7248 13.9728L18.7209 13.9761L18.7122 13.9832L18.7005 13.9927L18.691 14.0001C18.6751 14.0124 18.6558 14.0268 18.6328 14.0429C18.5868 14.0751 18.5264 14.1142 18.4501 14.1575C18.2974 14.2442 18.0824 14.347 17.7939 14.4452C17.2165 14.6419 16.3522 14.8182 15.1111 14.8182C13.8143 14.8182 12.7377 14.4513 11.7847 14.1267L11.7477 14.1141C10.7654 13.7795 9.90867 13.4935 8.88889 13.4935C7.79661 13.4935 7.10535 13.6484 6.71059 13.7829C6.65284 13.8026 6.60127 13.8219 6.55556 13.8402L6.55556 20.2273C6.55556 20.654 6.20733 21 5.77778 21C5.34822 21 5 20.654 5 20.2273V13.3831V13.2727V5.43506C5 5.20949 5.09922 4.99517 5.27161 4.84837L5.77778 5.43506C5.27161 4.84837 5.27204 4.848 5.27247 4.84763L5.27336 4.84688L5.27518 4.84534L5.27907 4.84209L5.28778 4.83493C5.29401 4.82987 5.30108 4.82425 5.30902 4.8181C5.32491 4.8058 5.34424 4.79143 5.36722 4.77531C5.41321 4.74306 5.47361 4.70396 5.54988 4.66066C5.70263 4.57394 5.9176 4.4712 6.20608 4.37294Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.6099e7fa.svg";
export { ForwardRef as ReactComponent };